import axios from 'axios';
import { ButtonGroup, ComboBox, DataGrid, Dialog, Form, FormField, GridColumn, Label, Layout, LayoutPanel, LinkButton, Panel, TextBox } from 'rc-easyui';
import React, { Component } from 'react';
import { uAPIlocal } from '../../lib/config';
import Loader from 'react-loader-spinner';
import {
    Row,
    Col,
} from "react-bootstrap";
import DayPicker, { DateUtils } from 'react-day-picker';
import MomentLocaleUtils from 'react-day-picker/moment';
import 'react-day-picker/lib/style.css';
import moment from "moment";
import { gapi } from 'gapi-script';
import jsonHoliday from './holiday';
import { Button, DatePicker, TimePicker, Checkbox, Select, Space, Flex, Radio } from 'antd';
import dayjs from 'dayjs';
import Swal from "sweetalert2";
import 'moment/locale/id';
moment.locale('id');

const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
    },
    buttonsStyling: false,
});

class MasterKonsultasi extends Component {
    constructor(props) {
        super(props);
        this.state = {
            master_konsultasi: {
                total: 0,
                pageSize: 20,
                data: [],
                pagePosition: "bottom",
                pageOptions: {
                    layout: ['list', 'sep', 'first', 'prev', 'next', 'last', 'sep', 'refresh', 'sep', 'manual', 'info']
                },
                selection: null,
                loading: true,
            },
            formTambah: {
                field: {
                    NAMA_KONSULTASI: "",
                    KATEGORI_KONSULTASI: "",
                    HARGA_KONSULTASI: "",
                    // JAM_PRAKTIK: "",
                },
                rules: {
                    NAMA_KONSULTASI: ["required"],
                    KATEGORI_KONSULTASI: ["required"],
                    HARGA_KONSULTASI: ["required"],
                }
            },
            formEdit: {
                field: {
                    NAMA_KONSULTASI: "",
                    KATEGORI_KONSULTASI: "",
                    HARGA_KONSULTASI: "",
                    branch_code: "",
                    // JAM_PRAKTIK: "",
                },
                rules: {
                    NAMA_KONSULTASI: ["required"],
                    KATEGORI_KONSULTASI: ["required"],
                    HARGA_KONSULTASI: ["required"],
                }
            },
            loader: false,
            selectedDays: [],
            selectedDaysOption: [],
            Days: [],
            holiday: [],
            TimeRanges: [],
            disabledDays: [],
            disabledDaysRecent: [],
            rangeJam: "",
            opsiJam: [],
            rangeJamRecent: "",
            opsiJamRecent: [],
            _selectedDay: "",
            opsiJamTanggal: [],
            _selectedRange: [{ value: 20, label: "20 Menit" }],
            editMode: 0,
            closed: true,
            // _selectedRange: 20,
        }
        this.errorDialog = React.createRef();
        this.tambahConc = React.createRef();
        this.editConc = React.createRef();

        this.pageChange = this.pageChange.bind(this);
        this.selectionChange = this.selectionChange.bind(this);

        this.formTambah = React.createRef();
        this.handleChangeFormTambah = this.handleChangeFormTambah.bind(this);
        this.handleSubmitFormTambah = this.handleSubmitFormTambah.bind(this);
        this.handleSubmitTambahJam = this.handleSubmitTambahJam.bind(this);

        this.formEdit = React.createRef();
        this.handleEditClick = this.handleEditClick.bind(this);
        this.onChangeMode = this.onChangeMode.bind(this);
        this.handleChangeformEdit = this.handleChangeformEdit.bind(this);
        this.handleSubmitformEdit = this.handleSubmitformEdit.bind(this);

        this.removeDialog = React.createRef();
        this.removedData = this.removedData.bind(this);
        this.handleRemoveClick = this.handleRemoveClick.bind(this);
        this.getDokter = this.getDokter.bind(this);
        this.getKonsultasi = this.getKonsultasi.bind(this);
        this.getBranch = this.getBranch.bind(this);
        this.handleDayClick = this.handleDayClick.bind(this);
        this.handleDayClickAdd = this.handleDayClickAdd.bind(this);
    }

    async getData() {
        await axios.post(uAPIlocal + '/api/v1/dokterkonsultasi')
            .then(function (response) {
                return response.data.results;
            })
            .then(response => {
                console.log("ini data dokter konsul", response);

                const data = response.sort(function (a, b) {
                    return a.NAMA_DOKTER < b.NAMA_DOKTER ? -1 : a.NAMA_DOKTER > b.NAMA_DOKTER ? 1 : 0;
                });

                setTimeout(() => {
                    this.getJadwal(data);
                }, 1000);

            })
            .catch(function (error) {
                console.log(error);
            });
    }

    getEvents() {

        // gapi.load('client', () => {
        //     gapi.client.init({
        //         apiKey: 'AIzaSyC8IUhutHMsapW-yYWSgrGmN8Pf3W_wcbA',
        //         clientId: '98416715227-u6mu3sgmph5n6mqk009r4tfo3gii01uq.apps.googleusercontent.com',
        //         scope: 'https://www.googleapis.com/auth/calendar',
        //         discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest'],
        //     }).then(() => {
        //         var request = gapi.client.request({
        //             'path': "https://www.googleapis.com/calendar/v3/calendars/en.indonesian%23holiday%40group.v.calendar.google.com/events?key=AIzaSyC8IUhutHMsapW-yYWSgrGmN8Pf3W_wcbA",
        //         });

        //         request.execute(function (event) {
        //             console.log("ini libur", event);
        //             let _holiday = [];
        //             let _summary = ["New Year's Day", "Ascension of the Prophet Muhammad", "Lunar New Year's Day", "Bali's Day of Silence and Hindu New Year (Nyepi)", "Good Friday", "Easter Sunday", "Idul Fitri", "Idul Fitri Holiday", "International Labor Day", "Ascension Day of Jesus Christ", "Waisak Day (Buddha's Anniversary)", "Pancasila Day", "Idul Adha", "Muharram / Islamic New Year", "Indonesian Independence Day", "Maulid Nabi Muhammad (The Prophet Muhammad's Birthday)", "Christmas Day"];
        //             event.items.map((item, index) => {
        //                 // console.log("ini libur", item.summary);
        //                 // console.log("ini libur", item.start.date);
        //                 if (moment(item.start.date, "YYYY-MM-DD").format("YYYY") == moment().year()) {
        //                     // _holiday.push({ date: item.start.date, detail: item.summary });
        //                     if (_summary.includes(item.summary)) {
        //                         if (item.summary == "Maulid Nabi Muhammad (The Prophet Muhammad's Birthday)") {
        //                             let addOne = moment(item.start.date).add(1, 'days');
        //                             // alert(addOne);
        //                             _holiday.push(moment(addOne).format("YYYY-MM-DD"));
        //                         } else {
        //                             _holiday.push(item.start.date);
        //                         }
        //                     }
        //                 }
        //                 localStorage.removeItem("_holiday");
        //                 localStorage.setItem("_holiday", _holiday);
        //             })


        //         });

        //     })
        // })

        console.log("ini jsonHoliday", jsonHoliday);

        let event = jsonHoliday;
        let _holiday = [];
        let _summary = ["New Year's Day", "Ascension of the Prophet Muhammad", "Lunar New Year's Day", "Bali's Day of Silence and Hindu New Year (Nyepi)", "Good Friday", "Easter Sunday", "Idul Fitri", "Idul Fitri Holiday", "International Labor Day", "Ascension Day of Jesus Christ", "Waisak Day (Buddha's Anniversary)", "Pancasila Day", "Idul Adha", "Muharram / Islamic New Year", "Indonesian Independence Day", "Maulid Nabi Muhammad (The Prophet Muhammad's Birthday)", "Christmas Day"];
        event.items.map((item, index) => {
            // console.log("ini libur", item.summary);
            // console.log("ini libur", item.start.date);
            if (moment(item.start.date, "YYYY-MM-DD").format("YYYY") == moment().year()) {
                // _holiday.push({ date: item.start.date, detail: item.summary });
                if (_summary.includes(item.summary)) {
                    if (item.summary == "Maulid Nabi Muhammad (The Prophet Muhammad's Birthday)") {
                        let addOne = moment(item.start.date).add(1, 'days');
                        // alert(addOne);
                        _holiday.push(moment(addOne).format("YYYY-MM-DD"));
                    } else {
                        _holiday.push(item.start.date);
                    }
                }
            }
            localStorage.removeItem("_holiday");
            localStorage.setItem("_holiday", _holiday);
        })

        setTimeout(() => {
            var partsOfStr = localStorage.getItem("_holiday").split(',');
            console.log("ini kejutan", partsOfStr);

            const disabledDays = this.state.disabledDays.concat();
            partsOfStr.map(item => (
                disabledDays.push(new Date(moment(item, "YYYY-MM-DD").format("YYYY"), moment(item, "YYYY-MM-DD").format("M") - 1, moment(item, "YYYY-MM-DD").format("DD")))
            ))

            disabledDays.push({ daysOfWeek: [0] });
            // disabledDays.push({ before: new Date() });
            this.setState({ disabledDays: disabledDays, disabledDaysRecent: disabledDays }, () => console.log("ini adalah selectedday", this.state.disabledDays));
        }, 2000);

    }


    async getJadwal(response) {
        this.setState({
            master_konsultasi: {
                ...this.state.master_konsultasi,
                data: [],
                // loading: false
            }
        })
        response.map((item, index) => {
            axios.post(uAPIlocal + `/api/v1/jadwaldokter/${item.ID_PENUGASAN}`)
                .then((res) => {
                    // console.log('hasil', res.data)
                    let _item = item;
                    var newKey = "JADWAL";
                    var newVal = res.data.results;
                    item[newKey] = newVal;
                    this.setState({
                        master_konsultasi: {
                            ...this.state.master_konsultasi,
                            data: [...this.state.master_konsultasi.data, item],
                        }
                    })
                    if (response.length == (index + 1)) {
                        setTimeout(() => {
                            this.getJam(this.state.master_konsultasi.data);
                        }, 1000);
                        this.setState({
                            // loading: false
                        })
                    }

                })
                .catch((err) => {
                    console.log('err', err)
                    if (axios.isCancel(err)) {
                        console.log('Request canceled', err.message);
                    } else { }
                })
        })
    }

    async getJam(response) {
        this.setState({
            master_konsultasi: {
                ...this.state.master_konsultasi,
                data: [],
                // loading: false
            }
        })
        response.map((item, index) => {
            axios.post(uAPIlocal + `/api/v1/jamdokter/${item.ID_PENUGASAN}`)
                .then((res) => {
                    console.log('hasil jam', res.data)
                    var newKey = "JAM";
                    var newVal = res.data.results;
                    item[newKey] = newVal;
                    this.setState({
                        master_konsultasi: {
                            ...this.state.master_konsultasi,
                            data: [...this.state.master_konsultasi.data, item],
                        }
                    })
                    if (response.length == (index + 1)) {
                        // this.setState({
                        //                         master_konsultasi: {data: []}
                        //                     })

                        setTimeout(() => {
                            const _datas = this.state.master_konsultasi.data.sort(function (a, b) {
                                return a.ID_DOKTER - b.ID_DOKTER;
                            });

                            console.log("INI DATA FIXED", _datas);

                            this.setState({
                                master_konsultasi: {
                                    ...this.state.master_konsultasi,
                                    data: [],
                                }
                            })

                            this.setState({
                                master_konsultasi: {
                                    ...this.state.master_konsultasi,
                                    data: _datas,
                                    loading: false
                                }
                            })


                        }, 1000);




                    }

                })
                .catch((err) => {
                    console.log('err', err)
                    if (axios.isCancel(err)) {
                        console.log('Request canceled', err.message);
                    } else { }
                })
        })
    }

    async getDokter() {
        await axios.post(uAPIlocal + `/api/v1/dokter`)
            .then(response =>
                // console.log("ini Branch",response),
                response.data.results.map(item => ({
                    value: `${item.ID_DOKTER}`,
                    text: `${item.NAMA_DOKTER}`,
                }))
            )
            .then(Dokter => {
                this.setState({
                    Dokter: Dokter,
                    chooseDokter: Dokter[0],
                })
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    async getKonsultasi() {
        await axios.post(uAPIlocal + `/api/v1/konsultasi`)
            .then(response =>
                // console.log("ini Branch",response),
                response.data.results.map(item => ({
                    value: `${item.ID_KONSULTASI}` + "/" + `${item.branch_code}`,
                    text: `${item.NAMA_KONSULTASI}` + " - " + `${item.branch_name}`,
                }))
            )
            .then(Konsultasi => {
                this.setState({
                    Konsultasi: Konsultasi,
                    chooseKonsultasi: Konsultasi[0],
                })
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    async getBranch() {
        await axios.post(uAPIlocal + `/api/v1/branch`)
            .then(response =>
                // console.log("ini Branch",response),
                response.data.results.map(item => ({
                    value: `${item.branch_code}`,
                    text: `${item.branch_name}`,
                }))
            )
            .then(Branch => {
                this.setState({
                    Branch: Branch,
                    chooseBranch: Branch[0],
                })
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    changeSelectDokter = (e) => {
        this.setState({ chooseDokter: e })
    }

    changeSelectKonsultasi = (e) => {
        this.setState({ chooseKonsultasi: e })
    }

    changeSelectBranch = (e) => {
        this.setState({ chooseBranch: e })
    }

    pageChange(event) {
        // console.log(event)
        if (event.refresh) {
            // console.log(event)
            this.setState({
                master_konsultasi: {
                    ...this.state.master_konsultasi,
                    loading: true,
                    selection: null
                },
            })
            this.getData();
        }

    }
    async selectionChange(event) {
        // console.log(event)
        let indexDokter = this.state.Dokter.findIndex(function (item, i) {
            return item.value == event.ID_DOKTER
        });
        let indexKonsultasi = this.state.Konsultasi.findIndex(function (item, i) {
            var _item = item.value.split("/");
            return _item[0] == event.ID_KONSULTASI
        });
        let indexBranch = this.state.Branch.findIndex(function (item, i) {
            return item.value == event.branch_code
        });
        await this.setState({
            master_konsultasi: {
                ...this.state.master_konsultasi,
                selection: event
            },
            chooseDokter: this.state.Dokter[indexDokter],
            chooseBranch: this.state.Branch[indexBranch],
            chooseKonsultasi: this.state.Konsultasi[indexKonsultasi],
        })
    }

    async handleOpenFormTambah() {
        this.tambahConc.current.open();
        // this.setState({ selectedDays: [], Days: [], TimeRanges: [], opsiJam: [], rangeJamRecent: "", opsiJamRecent: [] });
        this.setState({
            selectedDays: [],
            selectedDaysOption: [],
            Days: [],
            TimeRanges: [],
            opsiJam: [],
            opsiJamTanggal: [],
            opsiJamRecent: [],
            _selectedDay: "",
            rangeJamRecent: "",
            _selectedRange: [{ value: 20, label: "20 Menit" }],
        });
    }

    async handleChangeFormTambah(name, value) {
        let field = Object.assign({}, this.state.formTambah.field);
        field[name] = value;
        await this.setState({
            formTambah: {
                ...this.state.formTambah,
                field: field
            }
        }, () => console.log(this.state.formTambah.field))
    }

    async handleSubmitTambahJam() {
        console.log("ini _selectedDay", this.state._selectedDay);
        console.log(this.state.opsiJam);


        let _jamSelected = this.state.opsiJamTanggal.concat();

        if (this.state.opsiJamTanggal.length > 0) {
            var jp = [];
            this.state.opsiJamTanggal.map((item, i) => {
                if (item.date == this.state._selectedDay) {
                    jp.push(item);
                }
            })

            if (jp.length > 0) {
                let jp_selected = [];
                this.state.opsiJamTanggal.map((item, i) => {
                    if (item.date != this.state._selectedDay) {
                        jp_selected.push(item)
                    }
                })


                _jamSelected = jp_selected;
                console.log("ini _jamSelected", jp_selected);

            }


        }

        this.state.opsiJam.map((item, i) => {
            if (item.checked) {
                _jamSelected.push(
                    {
                        id: i,
                        title: item.title,
                        date: this.state._selectedDay,
                        range: this.state.rangeJam,
                        menit: this.state._selectedRange[0].value,
                        checked: true,
                    }
                )
            }
        })

        this.setState({ TimeRanges: [], opsiJam: [], opsiJamTanggal: _jamSelected, _selectedDay: "" }, () => console.log("ini jam untuk tanggal", this.state.opsiJamTanggal));

        swalWithBootstrapButtons
            .fire({
                icon: "success",
                title: "berhasil disimpan",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 1000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", Swal.stopTimer);
                    toast.addEventListener("mouseleave", Swal.resumeTimer);
                },
            })
            .then(function () { });

    }

    async handleSubmitFormTambah() {
        const formData = new FormData();
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        };

        let _val = this.state.chooseKonsultasi.split("/");
        formData.append('ID_DOKTER', this.state.chooseDokter);
        formData.append('ID_KONSULTASI', _val[0]);
        formData.append('branch_code', _val[1]);

        let selectDays = [];

        this.state.selectedDays.map((item, i) => {
            selectDays.push(moment(item).format("YYYY-MM-DD"));
        })

        let _jam = [];
        let _selectDays = [];

        this.state.opsiJamTanggal.map((item, i) => {
            console.log("ini detail item", item)
            if (selectDays.includes(item.date) == true) {
                if (item.checked == true) {
                    _jam.push({
                        "title": item.title,
                        "date": item.date,
                        "range": item.range,
                        "menit": item.menit
                    });

                    _selectDays.push({
                        "date": item.date,
                        "range": item.range,
                        "menit": item.menit
                    })
                }
            }
        })

        const uniqueDate = _selectDays.filter((value, index, self) => self.map(x => x.date).indexOf(value.date) == index)
        console.log('unique date', uniqueDate);


        console.log("ini tanggal fixed", _selectDays);
        console.log("ini jam fixed", _jam)

        formData.append('date', JSON.stringify(uniqueDate));
        formData.append('time', JSON.stringify(_jam));

        for (var pair of formData.entries()) {
            console.log(pair[0] + ': ' + pair[1]);
        }

        if (!this.state.chooseDokter) {
            this.setState({
                errorMessage: "Form tidak boleh kosong!",
            })
            this.errorDialog.current.open();
        } else if (this.state.selectedDays.length == 0) {
            this.setState({
                errorMessage: "Jadwal harus diisi!",
            })
            this.errorDialog.current.open();
        } else {
            await axios.post(uAPIlocal + '/api/v1/master_dokterkonsultasi', formData, config)
                .then(response => {
                    console.log("ini response add", response)
                    if (response.data.status === 406) {
                        this.setState({
                            errorMessage: response.data.message,
                        })
                        this.errorDialog.current.open();
                    } else {
                        this.getData();
                        this.tambahConc.current.close();
                        this.setState({
                            formTambah: {
                                ...this.state.formTambah,
                                field: {
                                    // NAMA_KONSULTASI: "",
                                    // KATEGORI_KONSULTASI: "",
                                    // HARGA_KONSULTASI: "",
                                    JAM_PRAKTIK: "",
                                },
                            },
                            chooseDokter: this.state.Dokter[0],
                            chooseKonsultasi: this.state.Konsultasi[0],
                            chooseBranch: this.state.Branch[0],
                        })

                        this.setState({ selectedDays: [], Days: [], TimeRanges: [], opsiJam: [], rangeJamRecent: "", opsiJamRecent: [] });
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        }

    }

    async handleRemoveClick() {
        this.setState({ Days: [] });
        if (this.state.master_konsultasi.selection) {
            const selectedDays = this.state.Days.concat();
            this.state.master_konsultasi.selection.JADWAL.map(item => (
                selectedDays.push(new Date(moment(item.date).format("YYYY"), moment(item.date).format("M") - 1, moment(item.date).format("DD")))
            ))
            this.setState({ Days: selectedDays }, () => console.log("ini adalah selectedday", this.state.selectedDays));
            this.removeDialog.current.open();

        } else {
            // console.log('tidak ada yang di select');
            this.setState({
                errorMessage: "Tidak Ada Data yang Dipilih",
            })
            this.errorDialog.current.open();
        }
    }

    async removedData() {
        await this.setState({
            loader: true
        })

        const formData = new FormData();


        const id = this.state.master_konsultasi.selection.ID_PENUGASAN;
        formData.append('id', id);
        let deleteDays = [];
        this.state.Days.map((item, i) => {
            deleteDays.push(moment(item).format("YYYY-MM-DD"));
        })

        formData.append('deleteDays', JSON.stringify(deleteDays));

        // await axios.delete(uAPIlocal + `/api/v1/master_dokterkonsultasi}`, formData, config)
        axios({
            method: "delete",
            url: uAPIlocal + "/api/v1/master_dokterkonsultasi",
            data: formData,
            headers: {
                'content-type': 'multipart/form-data'
            }
        })
            .then(function (response) {
                // console.log(response)this.state.pasien.selection.id_regis
                return response.data;
            })
            .then(response => {
                // console.log(response)
                this.getData();
                this.removeDialog.current.close();
                this.setState({
                    loader: false,
                    master_konsultasi: {
                        ...this.state.master_konsultasi,
                        selection: null
                    },
                })




            })
            .catch(error => {
                console.log(error);
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    // console.log(error.response.data);
                    // console.log(error.response.status);
                    // console.log(error.response.headers);
                    if (error.response.status === 500) {
                        this.setState({
                            loader: false,
                            errorMessage: error.response.data,
                        })
                        this.errorDialog.current.open();
                    }
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    // console.log(error.request);
                    this.setState({
                        loader: false,
                        errorMessage: "Terjadi Kesalahan",
                    })
                    this.errorDialog.current.open();
                } else {
                    // Something happened in setting up the request that triggered an Error
                    // console.log('Error', error.message);
                    this.setState({
                        loader: false,
                        errorMessage: "Terjadi Kesalahan",
                    })
                    this.errorDialog.current.open();
                }

            });
    }

    onChangeMode = (e) => {
        console.log(`radio checked:${e.target.value}`);
        this.setState({ editMode: e.target.value }, () => this.handleEditClick());
    };

    async handleEditClick() {

        this.setState({
            closed: false,
            selectedDays: [],
            selectedDaysOption: [],
            Days: [],
            TimeRanges: [],
            opsiJam: [],
            opsiJamTanggal: [],
            opsiJamRecent: [],
            _selectedDay: "",
            rangeJamRecent: "",
            _selectedRange: [{ value: 20, label: "20 Menit" }],
            disabledDays: this.state.disabledDaysRecent,
        }, () => this.handleEditNext());
        console.log("ini selection", this.state.master_konsultasi.selection);

    }

    async handleEditNext(value) {
        // console.log("handleEditNext",value)
        let _jamSelected = this.state.opsiJamTanggal.concat();
        this.state.master_konsultasi.selection.JAM.map((item, i) => {
            _jamSelected.push(
                {
                    id: i,
                    title: item.jam,
                    date: moment(item.date).format("YYYY-MM-DD"),
                    range: this.state.master_konsultasi.selection.JADWAL.find(i => moment(i.date).format("YYYY-MM-DD") === moment(item.date).format("YYYY-MM-DD")).JAM_PRAKTIK,
                    menit: this.state.master_konsultasi.selection.JADWAL.find(i => moment(i.date).format("YYYY-MM-DD") === moment(item.date).format("YYYY-MM-DD")).RANGE_MENIT,
                    checked: true
                }
            )
        })

        console.log("ini jam loh 2", _jamSelected)
        this.setState({ TimeRanges: [], opsiJam: [], opsiJamTanggal: _jamSelected, opsiJamRecent: _jamSelected, _selectedDay: "" }, () => console.log("ini jam untuk tanggal", this.state.opsiJamTanggal));

        if (this.state.master_konsultasi.selection) {
            console.log("ini konsul", this.state.master_konsultasi.selection)
            const NAMA_KONSULTASI = `${this.state.master_konsultasi.selection.NAMA_KONSULTASI}`
            const KATEGORI_KONSULTASI = `${this.state.master_konsultasi.selection.KATEGORI_KONSULTASI}`
            const HARGA_KONSULTASI = `${this.state.master_konsultasi.selection.HARGA_KONSULTASI}`
            // const JAM_PRAKTIK = `${this.state.master_konsultasi.selection.JAM_PRAKTIK}`

            this.setState({
                formEdit: {
                    ...this.state.formEdit,
                    field: {
                        // NAMA_KONSULTASI: NAMA_KONSULTASI,
                        // KATEGORI_KONSULTASI: KATEGORI_KONSULTASI,
                        // HARGA_KONSULTASI: HARGA_KONSULTASI,
                        // JAM_PRAKTIK: JAM_PRAKTIK
                    },
                },
            })

            const selectedDays = this.state.selectedDays.concat();
            const selectedDaysOption = this.state.selectedDaysOption.concat();
            // alert(this.state.editMode)
            if (this.state.editMode == 0) {
                this.state.master_konsultasi.selection.JADWAL.map((item, i) => {
                    selectedDays.push(new Date(moment(item.date).format("YYYY"), moment(item.date).format("M") - 1, moment(item.date).format("DD")))
                    selectedDaysOption.push({ value: moment(item.date).format("YYYY-MM-DD"), label: moment(item.date).format("DD-MM-YYYY") });
                })
                this.setState({ selectedDays: selectedDays, selectedDaysOption: selectedDaysOption, Days: selectedDays }, () => console.log("ini adalah selectedday", this.state.selectedDays));
            } else if (this.state.editMode == 1) {

                this.state.master_konsultasi.selection.JADWAL.map((item, i) => {
                    selectedDays.push(new Date(moment(item.date).format("YYYY"), moment(item.date).format("M") - 1, moment(item.date).format("DD")))
                    selectedDaysOption.push({ value: moment(item.date).format("YYYY-MM-DD"), label: moment(item.date).format("DD-MM-YYYY"), disabled: true, });
                })
                this.setState({ selectedDays: selectedDays, selectedDaysOption: selectedDaysOption, Days: selectedDays }, () => console.log("ini adalah selectedday", this.state.selectedDays));

                const disabledDays = this.state.disabledDays.concat();
                this.state.master_konsultasi.selection.JADWAL.map((item, i) => {
                    disabledDays.push(new Date(moment(item.date).format("YYYY"), moment(item.date).format("M") - 1, moment(item.date).format("DD")))
                    // selectedDaysOption.push({ value: moment(item.date).format("YYYY-MM-DD"), label: moment(item.date).format("DD-MM-YYYY") });
                })
                this.setState({ disabledDays: disabledDays }, () => console.log("ini adalah selectedday", this.state.disabledDays));
            } else {
                this.state.master_konsultasi.selection.JADWAL.map((item, i) => {
                    selectedDays.push(new Date(moment(item.date).format("YYYY"), moment(item.date).format("M") - 1, moment(item.date).format("DD")))
                    selectedDaysOption.push({ value: moment(item.date).format("YYYY-MM-DD"), label: moment(item.date).format("DD-MM-YYYY"), disabled: true, });
                })
                this.setState({ selectedDays: selectedDays, selectedDaysOption: selectedDaysOption, Days: selectedDays }, () => console.log("ini adalah selectedday", this.state.selectedDays));
            }

            this.editConc.current.open();
        } else {
            // console.log('tidak ada yang di select');
            this.setState({
                errorMessage: "Tidak Ada Data yang Dipilih",
            })
            this.errorDialog.current.open();
        }
    }

    async handleChangeformEdit(name, value) {
        let field = Object.assign({}, this.state.formEdit.field);
        field[name] = value;
        await this.setState({
            formEdit: {
                ...this.state.formEdit,
                field: field
            }
        })
    }
    async handleSubmitformEdit() {
        const formData = new FormData();
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        };

        formData.append('id', this.state.master_konsultasi.selection.ID_PENUGASAN);
        let _val = this.state.chooseKonsultasi.split("/");
        formData.append('ID_DOKTER', this.state.chooseDokter);
        formData.append('ID_KONSULTASI', _val[0]);
        formData.append('branch_code', _val[1]);

        console.log("perbandingan1", this.state.Days);
        console.log("perbandingan2", this.state.selectedDays);

        let days = [];
        this.state.Days.map((item, i) => {
            days.push(moment(item).format("YYYY-MM-DD"));
        })
        console.log("ini days", days)

        let selectDays = [];
        this.state.selectedDays.map((item, i) => {
            selectDays.push(moment(item).format("YYYY-MM-DD"));
        })

        let newInput = [];
        selectDays.map((item, i) => {
            if (days.includes(item) == false) {
                // newInput.push(item);
                newInput.push(moment(item).format("YYYY-MM-DD"));
            }
        })
        console.log("ini newInput ", newInput)

        let deleteDays = [];
        days.map((item, i) => {
            if (selectDays.includes(item) == false) {
                // deleteDays.push(item);
                deleteDays.push(moment(item).format("YYYY-MM-DD"));
            }
        })
        console.log("ini deleteDays ", deleteDays);

        if (deleteDays.length > 0) {
            formData.append('deleteDays', JSON.stringify(deleteDays));
        } else {
            formData.append('deleteDays', JSON.stringify([]));
        }

        console.log("opsiJamRecent", this.state.opsiJamRecent);
        console.log("opsiJamTanggal", this.state.opsiJamTanggal);

        // mohon dipertimbangkan mungkin ada kondisi, delete, new, dan update barengan
        if (deleteDays.length == 0 && newInput.length == 0) {
            // if (this.state.opsiJamRecent.length != this.state.opsiJamTanggal.length) {
            // bukan length aja klo RANGE JAM PRAKTIK beda langsung update
            let _jam = [];
            this.state.opsiJamTanggal.map((item, i) => {
                if (item.checked == true) {
                    _jam.push({
                        "title": item.title,
                        "date": item.date,
                        "range": item.range,
                        "menit": item.menit
                    });
                }
            })

            const uniqueDate = this.state.opsiJamRecent.filter((value, index, self) => self.map(x => x.date).indexOf(value.date) == index)
            const uniqueNewDate = _jam.filter((value, index, self) => self.map(x => x.date).indexOf(value.date) == index)
            console.log("ini tanggal uniqueDate", uniqueDate);
            console.log("ini tanggal uniqueNewDate", uniqueNewDate);

            let _update = [];
            uniqueDate.map((item, i) => {
                var result = uniqueNewDate.filter(x => x.date === item.date);
                if (result[0].menit != item.menit || result[0].range != item.range) {
                    _update.push({
                        "date": item.date,
                        "range": result[0].range,
                        "menit": result[0].menit
                    });
                }
            })

            console.log("ini final update", _update);
            formData.append('updateRange', JSON.stringify(_update));
            formData.append('updateJam', JSON.stringify(_jam));
            // } else {
            //     formData.append('updateJam', JSON.stringify([]));
            // }
        } else {
            formData.append('updateRange', JSON.stringify([]));
            formData.append('updateJam', JSON.stringify([]));
        }

        // input hari baru dan jam baru
        if (newInput.length > 0) {
            let _jamNewInputDays = [];
            let _newInputDays = [];
            this.state.opsiJamTanggal.map((item, i) => {
                console.log("ini detail item", item)
                if (newInput.includes(item.date) == true) {
                    if (item.checked == true) {
                        _jamNewInputDays.push({
                            "title": item.title,
                            "date": item.date,
                            "range": item.range,
                            "menit": item.menit
                        });

                        _newInputDays.push({
                            "date": item.date,
                            "range": item.range,
                            "menit": item.menit
                        })
                    }
                }
            })

            const uniqueDate_newInputDays = _newInputDays.filter((value, index, self) => self.map(x => x.date).indexOf(value.date) == index)
            console.log("ini tanggal newInputDays", uniqueDate_newInputDays);
            console.log("ini jam newInputDays", _jamNewInputDays)
            formData.append('newInputDays', JSON.stringify(uniqueDate_newInputDays));
            formData.append('newInputJam', JSON.stringify(_jamNewInputDays));
        } else {
            formData.append('newInputDays', JSON.stringify([]));
            formData.append('newInputJam', JSON.stringify([]));
        }


        for (var pair of formData.entries()) {
            console.log(pair[0] + ': ' + pair[1]);
        }


        if (!this.state.master_konsultasi.selection.ID_PENUGASAN) {
            this.setState({
                errorMessage: "Form tidak boleh kosong!",
            })
            this.errorDialog.current.open();

        } else {

            await axios.put(uAPIlocal + '/api/v1/master_dokterkonsultasi', formData, config)
                .then(response => {
                    if (response.data.status === 406) {
                        this.setState({
                            errorMessage: response.data.message,
                        })
                        this.errorDialog.current.open();
                    } else {
                        this.setState({
                            master_konsultasi: {
                                ...this.state.master_konsultasi,
                                loading: true,
                                selection: ''
                            }
                        })
                        this.getData();
                        this.editConc.current.close();
                        this.setState({
                            formEdit: {
                                ...this.state.formEdit,
                                field: {
                                    // NAMA_KONSULTASI: "",
                                    // KATEGORI_KONSULTASI: "",
                                    // HARGA_KONSULTASI: "",
                                    // JAM_PRAKTIK: "",
                                },
                            },
                            chooseDokter: this.state.Dokter[0],
                            chooseKonsultasi: this.state.Konsultasi[0],
                            chooseBranch: this.state.Branch[0],
                        })

                        this.setState({ selectedDays: [], selectedDaysOption: [], Days: [], TimeRanges: [], opsiJam: [], opsiJamTanggal: [], opsiJamRecent: [], _selectedDay: "", rangeJamRecent: "", });

                    }
                })
                .catch(function (error) {
                    console.log(error);
                });

        }

    }



    // handleDayClick(day, { selected }) {
    //     const selectedDays = this.state.selectedDays.concat();
    //     const selectedDaysOption = this.state.selectedDaysOption.concat();
    //     if (selected) {
    //         const selectedIndex = selectedDays.findIndex(selectedDay =>
    //             DateUtils.isSameDay(selectedDay, day)
    //         );
    //         selectedDays.splice(selectedIndex, 1);
    //         selectedDaysOption.splice({ value: moment(day).format("YYYY-MM-DD"), label: moment(day).format("YYYY-MM-DD") }, 1);
    //     } else {
    //         selectedDays.push(day);
    //         selectedDaysOption.push({ value: moment(day).format("YYYY-MM-DD"), label: moment(day).format("DD-MM-YYYY") });
    //     }
    //     this.setState({ selectedDays: selectedDays, selectedDaysOption: selectedDaysOption }, () => console.log("ini adalah selectedday", this.state.selectedDaysOption));
    // }

    handleDayClick(day, { selected }) {
        if (this.state.editMode == 1) {
            const selectedDays = this.state.selectedDays.concat();
            const selectedDaysOption = this.state.selectedDaysOption.concat();
            if (selected) {
                const selectedIndex = selectedDays.findIndex(selectedDay => moment(selectedDay).format("YYYY-MM-DD") === moment(day).format("YYYY-MM-DD"));
                selectedDays.splice(selectedIndex, 1);
                selectedDaysOption.splice(selectedIndex, 1);
            } else {
                selectedDays.push(day);
                selectedDaysOption.push({ value: moment(day).format("YYYY-MM-DD"), label: moment(day).format("DD-MM-YYYY") });
            }

            let sortabledate = selectedDaysOption.sort(function (a, b) {
                var aa = a.label.split('-').reverse().join(),
                    bb = b.label.split('-').reverse().join();
                return aa > bb ? -1 : (aa < bb ? 1 : 0);
            });

            this.setState({ selectedDays: selectedDays, selectedDaysOption: sortabledate }, () => console.log("ini adalah selectedday1", this.state.selectedDaysOption));
        } else if (this.state.editMode == 2) {
            const selectedDays = this.state.selectedDays.concat();
            const selectedDaysOption = this.state.selectedDaysOption.concat();
            if (selected) {
                const selectedIndex = selectedDays.findIndex(selectedDay => moment(selectedDay).format("YYYY-MM-DD") === moment(day).format("YYYY-MM-DD"));
                selectedDays.splice(selectedIndex, 1);
                selectedDaysOption.splice(selectedIndex, 1);
            } else {
                // selectedDays.push(day);
                // selectedDaysOption.push({ value: moment(day).format("YYYY-MM-DD"), label: moment(day).format("DD-MM-YYYY") });
            }
            this.setState({ selectedDays: selectedDays, selectedDaysOption: selectedDaysOption }, () => console.log("ini adalah selectedday2", this.state.selectedDaysOption));
        }
    }

    handleDayClickAdd(day, { selected }) {
        const selectedDays = this.state.selectedDays.concat();
        const selectedDaysOption = this.state.selectedDaysOption.concat();
        if (selected) {
            const selectedIndex = selectedDays.findIndex(selectedDay => moment(selectedDay).format("YYYY-MM-DD") === moment(day).format("YYYY-MM-DD"));
            selectedDays.splice(selectedIndex, 1);
            selectedDaysOption.splice(selectedIndex, 1);
        } else {
            selectedDays.push(day);
            selectedDaysOption.push({ value: moment(day).format("YYYY-MM-DD"), label: moment(day).format("DD-MM-YYYY") });
        }
        this.setState({ selectedDays: selectedDays, selectedDaysOption: selectedDaysOption }, () => console.log("ini adalah selectedday", this.state.selectedDaysOption));
    }



    onChange = (value) => {
        this.setState({ TimeRanges: [], opsiJam: [] });

        console.log("ini hasil ant", value);

        // alert(this.state._selectedRange[0].value)

        if (value) {
            this.setState({ TimeRanges: value });
            let start = moment(value[0].$H, 'H').format('HH') + ':00:00'
            let end = moment(value[1].$H, 'H').format('HH') + ':00:00'
            let range = value[0].$H + '-' + value[1].$H;
            this.setState({ rangeJam: range });
            var timesInBetween = [];
            var startH = parseInt(start.split(":")[0]);
            var startM = parseInt(start.split(":")[1]);
            var endH = parseInt(end.split(":")[0]);
            var endM = parseInt(end.split(":")[1]);

            // if (startM == 30)
            //     startH++;
            // for (var i = startH; i < endH; i++) {
            //     timesInBetween.push(i < 10 ? "0" + i + ":00" : i + ":00");
            //     timesInBetween.push(i < 10 ? "0" + i + ":30" : i + ":30");
            // }

            if (this.state._selectedRange[0].value == 10) {
                for (var i = startH; i < endH; i++) {
                    timesInBetween.push(i < 10 ? "0" + i + ":00" : i + ":00");
                    timesInBetween.push(i < 10 ? "0" + i + ":10" : i + ":10");
                    timesInBetween.push(i < 10 ? "0" + i + ":20" : i + ":20");
                    timesInBetween.push(i < 10 ? "0" + i + ":30" : i + ":30");
                    timesInBetween.push(i < 10 ? "0" + i + ":40" : i + ":40");
                    timesInBetween.push(i < 10 ? "0" + i + ":50" : i + ":50");
                }
            } else if (this.state._selectedRange[0].value == 15) {
                for (var i = startH; i < endH; i++) {
                    timesInBetween.push(i < 10 ? "0" + i + ":00" : i + ":00");
                    timesInBetween.push(i < 10 ? "0" + i + ":15" : i + ":15");
                    timesInBetween.push(i < 10 ? "0" + i + ":30" : i + ":30");
                    timesInBetween.push(i < 10 ? "0" + i + ":45" : i + ":45");
                }
            } else if (this.state._selectedRange[0].value == 20) {
                for (var i = startH; i < endH; i++) {
                    timesInBetween.push(i < 10 ? "0" + i + ":00" : i + ":00");
                    timesInBetween.push(i < 10 ? "0" + i + ":20" : i + ":20");
                    timesInBetween.push(i < 10 ? "0" + i + ":40" : i + ":40");
                }
            } else if (this.state._selectedRange[0].value == 30) {
                for (var i = startH; i < endH; i++) {
                    timesInBetween.push(i < 10 ? "0" + i + ":00" : i + ":00");
                    timesInBetween.push(i < 10 ? "0" + i + ":30" : i + ":30");
                }
            } else { }


            let _jam = [];
            timesInBetween.map((item, i) => {
                _jam.push(
                    {
                        id: i,
                        title: item,
                        checked: true,
                        range: range,
                        menit: this.state._selectedRange[0].value
                    }
                )
            })

            // buat history state opsijam dan timerange

            console.log("ini jam loh 1", _jam)
            this.setState({ opsiJam: _jam })
        }

    }

    onChangeJam = (item) => {
        this.setState({ opsiJam: this.state.opsiJam.map(e => e.id === item.id ? { ...e, checked: !item.checked } : e) });
    }

    componentDidMount() {

        console.log("ini now", dayjs('2', 'H', 'id'))
        this.getData();
        this.getDokter();
        this.getKonsultasi();
        this.getBranch();
        this.getEvents();
    }
    componentWillUnmount() {
        window.location.reload();
    }
    render() {

        const onClose = (e) => {
            if (!this.state.closed) {
                this.setState({ closed: true });
            }
        };

        const handleChange = (value) => {

            this.setState({ TimeRanges: [], opsiJam: [], _selectedDay: value, rangeJam: "" }, () => console.log("this.state._selectedDay", this.state._selectedDay))

            var jp = [];
            this.state.opsiJamTanggal.map((item, i) => {
                if (value == item.date) {
                    jp.push(item);
                }
            })

            console.log("ini _jp", jp);

            if (jp.length > 0) {
                var _jp = jp[0].range.split('-');
                var x = dayjs(_jp[0], 'H', 'id');
                var z = dayjs(_jp[1], 'H', 'id');

                this.setState({ TimeRanges: [x, z] });
                this.setState({
                    rangeJam: jp[0].range,
                    _selectedRange: [{ value: jp[0].menit, label: jp[0].menit + " Menit" }]
                });

                let start = moment(_jp[0], 'H').format('HH') + ':00:00';
                let end = moment(_jp[1], 'H').format('HH') + ':00:00';
                var timesInBetween = [];
                var startH = parseInt(start.split(":")[0]);
                var startM = parseInt(start.split(":")[1]);
                var endH = parseInt(end.split(":")[0]);
                var endM = parseInt(end.split(":")[1]);

                if (jp[0].menit == 10) {
                    for (var i = startH; i < endH; i++) {
                        timesInBetween.push(i < 10 ? "0" + i + ":00" : i + ":00");
                        timesInBetween.push(i < 10 ? "0" + i + ":10" : i + ":10");
                        timesInBetween.push(i < 10 ? "0" + i + ":20" : i + ":20");
                        timesInBetween.push(i < 10 ? "0" + i + ":30" : i + ":30");
                        timesInBetween.push(i < 10 ? "0" + i + ":40" : i + ":40");
                        timesInBetween.push(i < 10 ? "0" + i + ":50" : i + ":50");
                    }
                } else if (jp[0].menit == 15) {
                    for (var i = startH; i < endH; i++) {
                        timesInBetween.push(i < 10 ? "0" + i + ":00" : i + ":00");
                        timesInBetween.push(i < 10 ? "0" + i + ":15" : i + ":15");
                        timesInBetween.push(i < 10 ? "0" + i + ":30" : i + ":30");
                        timesInBetween.push(i < 10 ? "0" + i + ":45" : i + ":45");
                    }
                } else if (jp[0].menit == 20) {
                    for (var i = startH; i < endH; i++) {
                        timesInBetween.push(i < 10 ? "0" + i + ":00" : i + ":00");
                        timesInBetween.push(i < 10 ? "0" + i + ":20" : i + ":20");
                        timesInBetween.push(i < 10 ? "0" + i + ":40" : i + ":40");
                    }
                } else if (jp[0].menit == 30) {
                    for (var i = startH; i < endH; i++) {
                        timesInBetween.push(i < 10 ? "0" + i + ":00" : i + ":00");
                        timesInBetween.push(i < 10 ? "0" + i + ":30" : i + ":30");
                    }
                } else { }

                let _jam = [];
                jp.map((item, i) => {
                    _jam.push(item.title)
                })

                let _jamSelected = [];

                timesInBetween.map((item, i) => {
                    if (_jam.includes(item) == true) {
                        _jamSelected.push(
                            {
                                id: i,
                                title: item,
                                checked: true,
                                range: jp[0].range,
                                menit: jp[0].menit,
                            }
                        )
                    } else {
                        _jamSelected.push(
                            {
                                id: i,
                                title: item,
                                checked: false,
                                range: jp[0].range,
                                menit: jp[0].menit,
                            }
                        )
                    }

                })

                // console.log("ini jam loh", _jam)
                this.setState({ opsiJam: _jamSelected })
            }


        };

        const handleChangeForRange = (value) => {

            console.log("ini value loh", value)

            this.setState({ TimeRanges: [], opsiJam: [], rangeJam: "", _selectedRange: [{ value: value, label: value + " Menit" }] }, () => console.log("this.state._selectedDay", this.state._selectedDay))

            // this.setState({ _selectedRange: value }, () => console.log("this.state._selectedDay", this.state._selectedDay))

            // var jp = [];
            // this.state.opsiJamTanggal.map((item, i) => {
            //     if (this.state._selectedDay == item.date) {
            //         jp.push(item);
            //     }
            // })

            // console.log("ini _jp", jp);

            // if (jp.length > 0) {
            //     var _jp = jp[0].range.split('-');
            //     var x = dayjs(_jp[0], 'H', 'id');
            //     var z = dayjs(_jp[1], 'H', 'id');

            //     this.setState({ TimeRanges: [x, z] });
            //     this.setState({ rangeJam: jp[0].range });

            //     let start = moment(_jp[0], 'H').format('HH') + ':00:00';
            //     let end = moment(_jp[1], 'H').format('HH') + ':00:00';
            //     var timesInBetween = [];
            //     var startH = parseInt(start.split(":")[0]);
            //     var startM = parseInt(start.split(":")[1]);
            //     var endH = parseInt(end.split(":")[0]);
            //     var endM = parseInt(end.split(":")[1]);

            //     if (value == 10) {
            //         for (var i = startH; i < endH; i++) {
            //             timesInBetween.push(i < 10 ? "0" + i + ":00" : i + ":00");
            //             timesInBetween.push(i < 10 ? "0" + i + ":10" : i + ":10");
            //             timesInBetween.push(i < 10 ? "0" + i + ":20" : i + ":20");
            //             timesInBetween.push(i < 10 ? "0" + i + ":30" : i + ":30");
            //             timesInBetween.push(i < 10 ? "0" + i + ":40" : i + ":40");
            //             timesInBetween.push(i < 10 ? "0" + i + ":50" : i + ":50");
            //         }
            //     }else{
            //         for (var i = startH; i < endH; i++) {
            //             timesInBetween.push(i < 10 ? "0" + i + ":00" : i + ":00");
            //             timesInBetween.push(i < 10 ? "0" + i + ":20" : i + ":20");
            //             timesInBetween.push(i < 10 ? "0" + i + ":40" : i + ":40");
            //         }

            //     }


            //     let _jam = [];
            //     jp.map((item, i) => {
            //         _jam.push(item.title)
            //     })

            //     let _jamSelected = [];

            //     timesInBetween.map((item, i) => {
            //         if (_jam.includes(item) == true) {
            //             _jamSelected.push(
            //                 {
            //                     id: i,
            //                     title: item,
            //                     checked: true,
            //                     range: jp[0].range,
            //                 }
            //             )
            //         } else {
            //             _jamSelected.push(
            //                 {
            //                     id: i,
            //                     title: item,
            //                     checked: false,
            //                     range: jp[0].range,
            //                 }
            //             )
            //         }

            //     })

            //     // console.log("ini jam loh", _jam)
            //     this.setState({ opsiJam: _jamSelected })
            // }


        };

        return (


            <Row>
                <Dialog
                    title="Alert"
                    style={{ width: '300px', height: '84px' }}
                    modal
                    closed={true}
                    ref={this.errorDialog}
                >
                    <p style={{ textAlign: 'center', margin: '10px', fontSize: '16px' }}>{this.state.errorMessage}</p>
                </Dialog>

                <Dialog title="Tambah Dokter Konsultasi"
                    style={{ width: '380px', }}
                    modal
                    closed={true}
                    ref={this.tambahConc}
                >
                    <div className='pd-20'>
                        <Form
                            ref={this.formTambah}
                            style={{ maxWidth: 500, height: 400 }}
                            model={this.state.formTambah.field}
                            rules={this.state.formTambah.rules}
                            labelWidth={200}
                            // labelAlign="right"
                            labelPosition="top"
                            // floatingLabel
                            // validateRules={this.getCustomRules}
                            onChange={this.handleChangeFormTambah}
                            virtualScroll
                        >
                            <FormField name="ID_DOKTER" label="DOKTER">
                                <ComboBox onChange={this.changeSelectDokter}
                                    style={{ width: '100%', height: '40px' }} data={this.state.Dokter} value={this.state.chooseDokter} ></ComboBox>
                            </FormField>

                            <FormField name="ID_KONSULTASI" label="KONSULTASI / POLI">
                                <ComboBox
                                    onChange={this.changeSelectKonsultasi}
                                    style={{ width: '100%', height: '40px' }} data={this.state.Konsultasi} value={this.state.chooseKonsultasi} ></ComboBox>
                            </FormField>

                            <FormField name="JADWAL_TUGAS" label="JADWAL TUGAS">
                                <DayPicker
                                    selectedDays={this.state.selectedDays}
                                    onDayClick={this.handleDayClickAdd}
                                    localeUtils={MomentLocaleUtils}
                                    locale={'id'}
                                    fromMonth={new Date(moment().year(), 0)}
                                    toMonth={new Date(moment().year(), 11)}
                                    disabledDays={
                                        this.state.disabledDays
                                    }
                                />
                            </FormField>


                            <FormField name="s" label="TANGGAL UNTUK JAM PRAKTIK">
                                <Select
                                    // defaultValue={"-- Pilih Tanggal untuk Jam Praktik --"}
                                    value={this.state._selectedDay}
                                    style={{ width: '100%' }}
                                    onChange={handleChange}
                                    options={this.state.selectedDaysOption}
                                />
                            </FormField>

                            <FormField name="r" label="RANGE JAM PRAKTIK">
                                <Select
                                    // defaultValue={[{ value: 20, label: "20 Menit" }]}
                                    value={this.state._selectedRange}
                                    style={{ width: '100%' }}
                                    onChange={handleChangeForRange}
                                    options={[
                                        { value: 10, label: "10 Menit" },
                                        { value: 15, label: "15 Menit" },
                                        { value: 20, label: "20 Menit" },
                                        { value: 30, label: "30 Menit" }
                                    ]}
                                />
                            </FormField>


                            <FormField name="JAM_PRAKTIK" label="JAM PRAKTIK">
                                <TimePicker.RangePicker onChange={this.onChange} value={this.state.TimeRanges} format={"HH"} disabled={this.state._selectedDay ? false : true} />

                                <>
                                    <div style={{ width: '100%', padding: '10px' }}>
                                        <Row>
                                            {this.state.opsiJam.map((item) => (
                                                <Col span={8}>
                                                    <Checkbox
                                                        key={item.id}
                                                        checked={item.checked}
                                                        onChange={() => this.onChangeJam(item)}
                                                    >
                                                        {item.title}
                                                    </Checkbox>

                                                </Col>
                                            ))}

                                        </Row>
                                    </div>
                                </>

                                <LinkButton onClick={this.handleSubmitTambahJam} style={{ marginBottom: '20px' }} disabled={this.state._selectedDay ? false : true}>Simpan Jam</LinkButton>

                            </FormField>





                            {/* <FormField name="branch_code" label="CABANG">
                                <ComboBox onChange={this.changeSelectBranch}
                                    style={{ width: '100%', height: '40px' }} data={this.state.Branch} value={this.state.chooseBranch} ></ComboBox>
                            </FormField> */}
                            <FormField >
                                <LinkButton onClick={this.handleSubmitFormTambah} style={{ marginBottom: '20px' }}>Submit</LinkButton>

                                {/* <button className="btn btn-success btn-sm"
                                    style={{ marginBottom: '20px' }}
                                    onClick={this.handleSubmitFormTambah}
                                >
                                   
                                    Submit
                                </button> */}
                            </FormField>
                        </Form>
                    </div>
                </Dialog>

                <Dialog title="Edit Dokter Konsultasi"
                    style={{ width: '500px', }}
                    modal
                    closed={this.state.closed}
                    // closed={true}
                    // closable={false}
                    ref={this.editConc}
                >
                    <div className='pd-20'>
                        <Form
                            ref={this.formEdit}
                            style={{ maxWidth: 500, height: 400 }}
                            model={this.state.formEdit.field}
                            rules={this.state.formEdit.rules}
                            labelWidth={200}
                            // labelAlign="right"
                            labelPosition="top"
                            // floatingLabel
                            // validateRules={this.getCustomRules}
                            onChange={this.handleChangeformEdit}
                            virtualScroll
                        >
                            <FormField name="ID_DOKTER" label="DOKTER">
                                <ComboBox onChange={this.changeSelectDokter}
                                    style={{ width: '100%', height: '40px' }} data={this.state.Dokter} value={this.state.chooseDokter}  disabled></ComboBox>
                            </FormField>

                            <FormField name="ID_KONSULTASI" label="KONSULTASI / POLI">
                                <ComboBox
                                    onChange={this.changeSelectKonsultasi}
                                    style={{ width: '100%', height: '40px' }} data={this.state.Konsultasi} value={this.state.chooseKonsultasi}  disabled></ComboBox>
                            </FormField>



                            <div className="form-group">
                                <label className="form-label">Mode</label>
                                <Flex vertical gap="middle">
                                    <Radio.Group
                                        onChange={this.onChangeMode}
                                        // defaultValue={0}
                                        buttonStyle="solid"
                                        value={this.state.editMode}
                                    >
                                        <Radio.Button value={0}>{'UPDATE JAM'}</Radio.Button>
                                        <Radio.Button value={1}>{'TAMBAH HARI'}</Radio.Button>
                                        <Radio.Button value={2}>{'HAPUS HARI'}</Radio.Button>
                                    </Radio.Group>
                                </Flex>
                            </div>

                            {/* bikin dua date picker disini biar simple */}

                            <FormField name="JADWAL_TUGAS" label="JADWAL TUGAS" style={{ display: this.state.editMode == 0 ? 'none' : null }}>
                                <DayPicker
                                    selectedDays={this.state.selectedDays}
                                    onDayClick={this.handleDayClick}
                                    localeUtils={MomentLocaleUtils}
                                    locale={'id'}
                                    fromMonth={new Date(moment().year(), 0)}
                                    toMonth={new Date(moment().year(), 11)}
                                    disabledDays={
                                        this.state.disabledDays
                                    }
                                />
                            </FormField>

                            <FormField name="s" label="TANGGAL UNTUK JAM PRAKTIK" style={{ display: this.state.editMode == 2 ? 'none' : null }}>
                                <Select
                                    // defaultValue={"-- Pilih Tanggal untuk Jam Praktik --"}
                                    value={this.state._selectedDay}
                                    style={{ width: '100%' }}
                                    onChange={handleChange}
                                    options={this.state.selectedDaysOption}
                                />
                            </FormField>

                            <FormField name="r" label="RANGE JAM PRAKTIK" style={{ display: this.state.editMode == 2 ? 'none' : null }}>
                                <Select
                                    // defaultValue={[{ value: 20, label: "20 Menit" }]}
                                    value={this.state._selectedRange}
                                    style={{ width: '100%' }}
                                    onChange={handleChangeForRange}
                                    options={[
                                        { value: 10, label: "10 Menit" },
                                        { value: 15, label: "15 Menit" },
                                        { value: 20, label: "20 Menit" },
                                        { value: 30, label: "30 Menit" }
                                    ]}
                                />
                            </FormField>


                            <FormField name="JAM_PRAKTIK" label="JAM PRAKTIK" style={{ display: this.state.editMode == 2 ? 'none' : null }}>
                                <TimePicker.RangePicker onChange={this.onChange} value={this.state.TimeRanges} format={"HH"} disabled={this.state._selectedDay ? false : true} />

                                <>
                                    <div style={{ width: '100%', padding: '10px' }}>
                                        <Row>
                                            {this.state.opsiJam.map((item) => (
                                                <Col span={8}>
                                                    <Checkbox
                                                        key={item.id}
                                                        checked={item.checked}
                                                        onChange={() => this.onChangeJam(item)}
                                                    >
                                                        {item.title}
                                                    </Checkbox>

                                                </Col>
                                            ))}

                                        </Row>
                                    </div>
                                </>

                                <LinkButton onClick={this.handleSubmitTambahJam} style={{ marginBottom: '20px' }} disabled={this.state._selectedDay ? false : true}>Simpan Jam</LinkButton>

                            </FormField>



                            <FormField >
                                <LinkButton onClick={onClose} style={{ marginBottom: '4px' }}>Cancel</LinkButton>
                                <LinkButton onClick={this.handleSubmitformEdit} style={{ marginBottom: '20px' }}>Submit</LinkButton>
                            </FormField>
                        </Form>
                    </div>
                </Dialog>
                <Dialog
                    title="Please Confirm"
                    style={{ width: '300px', height: '190px' }}
                    modal
                    closed={true}
                    ref={this.removeDialog}
                    footer={() => {
                        return (
                            this.state.loader ? (
                                <div className="text-center">
                                    <Loader type="TailSpin" color="#00BFFF" height={40} width={100} />
                                </div>
                            ) : (

                                <>
                                    <ButtonGroup style={{ width: '100%', height: '50px' }}>
                                        <LinkButton className="f-full mybtn" plain onClick={this.removedData}>Yakin</LinkButton>
                                        <LinkButton className="f-full mybtn" plain onClick={() => this.removeDialog.current.close()}>Cancel</LinkButton>
                                    </ButtonGroup>
                                </>
                            )
                        )
                    }}

                >
                    <>
                        <p style={{ textAlign: 'center', margin: '10px', fontSize: '16px' }}>Apakah Anda Yakin?</p>

                    </>
                </Dialog>


                <Col md="12" style={{ backgroundColor: "white", padding: "2px" }}>
                    <Panel
                        title="Master Penugasan Dokter"
                        collapsible
                    // bodyStyle={{ padding: 20 }}
                    // style={{ height: 500 }}
                    >
                        <Row style={{ padding: 0, marginBottom: 4, marginLeft: 2 }}>
                            <Col className="col-8">


                                <div style={{ marginTop: 10, marginLeft: 4 }}>
                                    <LinkButton
                                        iconCls="icon-add"
                                        style={{ margin: 4 }}
                                        // onClick={() => this.addRow()}
                                        onClick={() => this.handleOpenFormTambah()}
                                    >
                                        Tambah
                                    </LinkButton>
                                    <LinkButton
                                        iconCls="icon-edit"
                                        style={{ margin: 4 }}
                                        // onClick={() => this.editRow()}
                                        onClick={this.handleEditClick}
                                        disabled={this.state.master_konsultasi.selection ? false : true}
                                    >
                                        Update
                                    </LinkButton>
                                    <LinkButton
                                        iconCls="icon-cancel"
                                        style={{ margin: 4 }}
                                        // onClick={() => this.deleteRow()}
                                        onClick={this.handleRemoveClick}
                                        disabled={this.state.master_konsultasi.selection ? false : true}
                                    >
                                        Hapus
                                    </LinkButton>


                                </div>
                            </Col>
                        </Row>

                        <div id="DataGrid">
                            <DataGrid
                                {...this.state.master_konsultasi}
                                style={{ height: '70vh', }}
                                pagination
                                columnResizing
                                selectionMode="single"
                                onSelectionChange={this.selectionChange}
                                // onPageChange={this.pageChange}
                                filterable
                                virtualScroll
                                columnMoving
                            >
                                {/* <GridColumn
                                    field="rn"
                                    align="center"
                                    width="30px"
                                    cellCss="datagrid-td-rownumber"
                                    render={({ rowIndex }) => <span>{rowIndex + 1}</span>}
                                    filterable={false}
                                /> */}
                                {/* <GridColumn
                                    field="ID_PENUGASAN"
                                    title="ID"
                                    align="center"
                                    width="20px"
                                ></GridColumn> */}

                                <GridColumn
                                    field="NAMA_DOKTER"
                                    title="NAMA DOKTER"
                                    align="center"
                                    width="80px"
                                ></GridColumn>
                                <GridColumn
                                    sortable
                                    field="NAMA_KONSULTASI"
                                    title="NAMA KONSULTASI / POLI"
                                    align="center"
                                    width="80px"
                                ></GridColumn>
                                <GridColumn
                                    field="branch_name"
                                    title="CABANG"
                                    // hidden="true"
                                    align="center"
                                    width="40px"
                                ></GridColumn>
                                <GridColumn
                                    field="rn"
                                    title={"JADWAL BULAN " + moment().format("MMMM").toUpperCase()}
                                    align="center"
                                    width="80px"
                                    // cellCss="datagrid-td-rownumber"
                                    render={({ row }) =>
                                        row.JADWAL.map((item, i) => {
                                            if (moment(item.date).format("MM-YYYY") == moment().format("MM-YYYY")){
                                                return <span style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{moment(item.date).format("DD-MM-YYYY")}{", "}</span>
                                            }

                                            // if (row.JADWAL.length == (i + 1)) {
                                            //     // if ()
                                            //     return <span style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{moment(item.date).format("DD-MM-YYYY")}{", "}</span>
                                            // }
                                            
                                            
                                        })
                                    }
                                // filterable={false}
                                />
                                {/* <GridColumn
                                    field="rn"
                                    title="JAM PRAKTIK"
                                    align="center"
                                    width="80px"
                                    render={({ row }) => {



                                        if (row.JAM) {

                                            const result = row.JAM.reduce((acc, { id, date, jam }) => {
                                                const existing = acc.find(i => i.date === date)
                                                if (existing) { existing.jam.push(jam) }
                                                else { acc.push({ id, date, jam: [jam] }) }
                                                return acc
                                            }, [])

                                            console.log('ini result', result);
                                            console.log("ini row jam", row.JAM.length)
                                            if (row.JAM.length > 0) {
                                                return <ul>
                                                    {result.map((item, i) => {
                                                            return <li style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', listStyleType: 'none' }}>
                                                                <Row style={{ margin: 10 }}>
                                                                    <Col><span style={{ textAlign: 'left' }}><b style={{}}>{moment(item.date).format("DD-MM-YYYY")}</b></span></Col>
                                                                    <Col><ul style={{ listStyleType: 'square', textAlign: 'left' }}>{item.jam.map((x, i) => { return <li>{x}</li> })}</ul></Col>
                                                                </Row>
                                                            </li>

                                                    })}
                                                </ul>
                                            } else {
                                                return <></>
                                            }
                                        }

                                    }
                                    }
                                /> */}

                                {/* <GridColumn
                                    field="rn"
                                    title="RANGE JAM PRAKTIK"
                                    align="center"
                                    width="50px"
                                    // cellCss="datagrid-td-rownumber"
                                    render={({ row }) => {
                                        if (row.JAM_PRAKTIK) {
                                            var _jp = row.JAM_PRAKTIK.split('-');
                                            return <>{moment(_jp[0], 'H').format('HH') + ':00' + " - " + moment(_jp[1], 'H').format('HH') + ':00'}</>
                                        }
                                    }
                                    }
                                // filterable={false}
                                /> */}

                            </DataGrid>
                        </div>
                    </Panel>
                </Col>
            </Row>
        )
    }
}
export default MasterKonsultasi